import React, { FC } from 'react'

import { IconProps } from '../Icon'
import { LinkProps } from '../Link'

import * as SC from './styled'

export type ActionButtonProps = LinkProps & {
  label?: string
  text?: string
  iconProps?: IconProps
  iconPosition?: 'left' | 'right'
  variant?: SC.ActionButtonVariant
  look?: SC.ActionButtonLook
  noTextOnMobile?: boolean
  bigPadding?: boolean
  noIconOnDesktop?: boolean
  children?: React.ReactNode
}

const ActionButton: FC<ActionButtonProps> = ({
  label,
  text,
  children,
  iconProps,
  iconPosition,
  variant = SC.ActionButtonVariant.primary,
  look = SC.ActionButtonLook.contained,
  noTextOnMobile = false,
  bigPadding = false,
  noIconOnDesktop = false,
  ...linkProps
}) => {
  return (
    <SC.ActionButton
      $variant={variant}
      $look={look}
      $noTextOnMobile={noTextOnMobile}
      $bigPadding={bigPadding}
      {...linkProps}
      // disabled={disabled}
      // {...(disabled === false && {
      //   onClick: onClick,
      // })}
    >
      {iconProps && (!iconPosition || iconPosition === 'left') && (
        <SC.ActionIcon $noIconOnDesktop={noIconOnDesktop} {...iconProps} />
      )}
      {(children || label || text) && (
        <SC.Label $noTextOnMobile={noTextOnMobile}>{children || label || text}</SC.Label>
      )}
      {iconProps && iconPosition === 'right' && (
        <SC.ActionIcon $noIconOnDesktop={noIconOnDesktop} {...iconProps} />
      )}
    </SC.ActionButton>
  )
}

export default ActionButton
